import { render, staticRenderFns } from "./PackageSummaryContent.vue?vue&type=template&id=553828a3&scoped=true"
import script from "./PackageSummaryContent.vue?vue&type=script&lang=js"
export * from "./PackageSummaryContent.vue?vue&type=script&lang=js"
import style0 from "./PackageSummaryContent.vue?vue&type=style&index=0&id=553828a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553828a3",
  null
  
)

export default component.exports